import { Routes } from '@angular/router';
import { AuthGuard } from '../../guard/auth-guard/auth.guard';
import { Role } from '../../core/enums/role.enum';

export const rmsRoutes: Routes = [
  {
    path: 'consultar-rms',
    canActivate: [AuthGuard],
    data: {
      title: 'Consultar RMS',
      roles: [Role.RMS_INDIVIDUAL_CONSULTAR],
      breadcrumb: [{ label: 'Consultar RMS', url: '/-consultar-rms' }],
    },
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./rms.component').then((m) => m.RmsComponent),
      },
      {
        path: 'gerenciar/:id',
        data: {
          title: 'Gerenciar RMS - Individual',
          roles: [Role.RMS_INDIVIDUAL_GERAR],
          breadcrumb: [
            { label: 'Consultar RMS', url: '/consultar-rms' },
            { label: 'Gerenciar RMS - Individual', url: '/rms/gerenciar/:id' },
          ],
        },
        loadComponent: () =>
          import('./gerenciar-rms-individual/gerenciar-rms-individual.component').then(
            (m) => m.GerenciarRmsIndividualComponent,
          ),
      },
      {
        path: 'gerenciar/:profissionalId/declaracao/:idRms',
        data: {
          title: 'Declaração do RMS',
          roles: [Role.RMS_INDIVIDUAL_GERAR_DECLARACAO],
          breadcrumb: [
            { label: 'RMS', url: '/rms' },
            { label: 'Gerenciar RMS - Individual', url: '/rms/gerenciar/:id' },
            { label: 'Declaração do RMS', url: '/rms/gerenciar/:profissionalId/declaracao/:idRms' },
          ],
        },
        loadComponent: () =>
          import('./declaracao-rms/declaracao-rms.component').then(
            (m) => m.DeclaracaoRmsComponent,
          ),
      },
    ],
  },
];
